import React from 'react';
import styled from 'styled-components/macro';
import translate from './TranslateHOC';

function PageTitle({ title, type, children }) {
  return (
    <H2 type={type}>
      {title}
      {children}
    </H2>
  );
}

const H2 = styled.h2`
  margin: auto;
  max-width: 1595px;
  ${(props) => props.theme.fontBold};
  font-weight: bold;
  font-size: 24px;
  letter-spacing: -0.025em;
  margin-bottom: 6px;
  padding: 1em 15px 12px;
  @media screen and (min-width: 768px) {
    font-size: 30px;
    padding-left: 0;
  }
  @media screen and (min-width: 1200px) {
    font-size: 36px;
    padding-bottom: 0.75em;
  }
  ${(props) =>
    props.type === 'cyw' &&
    `
    font-size: 20px;
    letter-spacing: -0.28px;
    margin-top: 15px;
    margin-bottom: 0.8em;
    padding: 0 15px;
    @media screen and (min-width: 768px) {
      font-size: 24px;
      margin-top: 23px;
      padding-left: 0;
    }
    @media screen and (min-width: 1200px) {
      padding-bottom: 0;
    }
  `};
`;

export default translate(PageTitle);
